const React = require("react");
const map = require("mn-utils/map");

const SearchFilter = require("../../../SearchFilter");
const SelectFilter = require("../../../SelectFilter");

module.exports = (props) => {

  const data = props.data;
  const onChange = props.onChange;

  const {
    // default data from high level
    search = {},
    selectFilters = [],
    hideTimeInterval,
    hideSearch,
    disabled,

    // components data from interval component
    TimeIntervalsComponent,
    searchComponent,
    selectComponent,
  } = props;

  return (
    <div className="(mv10)>1">
      {!hideTimeInterval && TimeIntervalsComponent && (
        <TimeIntervalsComponent
          data={data}
          onChange={onChange}
          disabled={disabled}
          mobile
        />
      )}
      {!hideSearch && (
        <div className="fx1">
          <SearchFilter
            data={data}
            search={search}
            searchComponent={searchComponent}
            onChange={onChange}
            disabled={disabled}
          />
        </div>
      )}
      {map(selectFilters, (selectParams, id) => (
        <div key={id}>
          <SelectFilter
            selectComponent={selectComponent}
            selectParams={selectParams}
            data={data}
            onChange={onChange}
            disabled={disabled}
          />
        </div>
      ))}
    </div>
  )
}
